import {Container, Grid, Typography, Button} from '@mui/material';
import 'react-datepicker/dist/react-datepicker.css';

import './index.css';
import Form from './Components/Form';
import {useEffect, useState} from 'react';
import {authentication} from './Services/Authentication';
import swal from 'sweetalert';
import {getImageUser} from './Services/Image';
import {getFields} from './Services/Fields';
import {validateData} from './Utils';
import {saveInfo, saveFile} from './Services/SaveForm';
import Loading from './Components/Loading';
import {findEquById} from './Services/FindEquById';
import {URL_HANDLER_VALIDATION} from './Utils/url_handler';
// Importar MSAL para la autenticación de Office 365
import {useMsal} from '@azure/msal-react';

const enableOfficeAuth = process.env.REACT_APP_ENABLE_OFFICE_AUTH === '1';

function App() {
  // Agregar nuevo estado para el número de serie
  const [serialNumber, setSerialNumber] = useState(null);
  const {instance, accounts} = useMsal(); // MSAL hooks para la autenticación de Office 365

  // Estado para verificar si el usuario ya pasó la autenticación de Office 365
  const [isOfficeAuthenticated, setIsOfficeAuthenticated] = useState(false);

  //Almacenamos los campos del formulario
  const [field, setFields] = useState({});

  //Almacenamos el logo de la empresa
  const [imageCompany, setImageCompany] = useState('');

  //Campos obligatorios
  const [error, setError] = useState({});

  //Campos obligatorios
  const [openLoading, setOpenLoading] = useState(false);

  //Campos obligatorios
  const [dependencyFilter, setDependencyFilter] = useState({});

  //Campos obligatorios
  const [valueField, setValueField] = useState({});
  //Campos para manejar la subida de un archivo
  const [fileInfo, setFileInfo] = useState({
    nombre: 'Archivo(jpg, png, pdf)',
    descripcion: '',
  });
  const [base64File, setBase64File] = useState({});

  // Autenticación con Office 365
  const handleOfficeLogin = async () => {
    try {
      await instance.loginPopup({
        scopes: ['User.Read'], // Permiso básico para leer datos del usuario
      });
      setIsOfficeAuthenticated(true);
      send(true);
    } catch (error) {
      console.error('Error en la autenticación con Office 365:', error);
      swal(
        'Error de autenticación',
        'No se pudo autenticar con Office 365. Intenta nuevamente.',
        'error',
      );
    }
  };

  const handleOfficeLogout = () => {
    instance.logoutPopup();
    setIsOfficeAuthenticated(false);
  };

  //Hacemos la autenticacion del usuario en SAMM
  async function send(key) {
    if (key) setOpenLoading(true);
    await authentication()
      .then(async response => {
        localStorage.setItem('user', response.data);
        if (key) getDataClient();
        setOpenLoading(false);
      })
      .catch(error => {
        if (key) {
          localStorage.removeItem('user');
          swal(
            'Problemas en la autenticación',
            'Hemos tenido problemas al intentar autenticarte, por favor revisa las credenciales del usuario: ' +
              process.env.REACT_APP_USER,
            'error',
          );
        }
        setOpenLoading(false);
      });
  }

  //Cada vez que el usuario entre al apiclativo lanzamos la autenticacion 1000
  useEffect(() => {
    if (isOfficeAuthenticated || !enableOfficeAuth) {
      localStorage.removeItem('user');

      // Obtenemos el token cada 8 minutos para que no vaya a expirar
      const interval = setInterval(() => send(false), 200000);

      // Obtenemos la información primaria
      send(true);

      // Limpia el intervalo cuando el componente se desmonte
      return () => clearInterval(interval);
    }
  }, []);

  async function getQREquipo(qrSerial) {
    const user = localStorage.getItem('user');
    if (qrSerial && user) {
      try {
        await findEquById(qrSerial, user)
          .then(response => {
            if (response && response.respuesta === 400) {
              swal(
                'Error',
                `${response.descripcion}, por favor comunicate con una persona de soporte`,
                'error',
              );
            } else if (!response) {
              swal(
                'Error',
                'No se pudo obtener información del equipo',
                'error',
              );
            }
            const respuesta = response.equ_equipo;

            setValueField(prevState => ({
              ...prevState,
              id_sucursal: respuesta.id_sucursal,
              id_equipo: respuesta.id,
              id_tercero_cliente: respuesta.id_tercero,
            }));
          })
          .catch(error => {
            console.error('Error al buscar equipo:', error);
            swal('Error', 'Hubo un problema al buscar el equipo', 'error');
          });
      } catch (error) {
        console.error('Error general:', error);
        swal('Error', 'Ocurrió un error inesperado', 'error');
      }
    }
  }

  //Obtenemos la informacion del cliente
  async function getDataClient() {
    setOpenLoading(true);
    await getImageUser()
      .then(response => {
        setImageCompany(response.data.img);
      })
      .catch(error => {
        setOpenLoading(false);
      });

    let fields;
    await getFields()
      .then(response => {
        fields = response.data;
      })
      .catch(error => {
        setOpenLoading(false);
        swal(
          'Error',
          'Hemos tenido problemas al obtener los campos del formulario, por favor comunicate con una persona de soporte',
          'error',
        );
      });
    const urlParams = new URLSearchParams(window.location.search);
    const qr = urlParams.get('qr');

    if (qr) {
      setSerialNumber(qr);
      await getQREquipo(qr);
    }

    if (fields) {
      const containQr = qr ? true : false;
      const newFields = URL_HANDLER_VALIDATION(
        window.location.search,
        fields,
        containQr,
      );
      fields = newFields;
      const fieldsValue = fields.principales.reduce((acc, field) => {
        if (field.parametro) {
          acc[field.id] = field.parametro.valor;
        }
        return acc;
      }, {});

      const atributosConvert = () => {
        let convertedInfo = {};
        fields.atributos.forEach(atributo => {
          if (atributo.parametro) {
            convertedInfo[atributo.id] = atributo.parametro.valor;
          } else {
            convertedInfo[atributo.id] = null;
          }
        });
        return convertedInfo;
      };

      const fieldsConvert = () => {
        let convertedInfo = {};
        Object.entries(fieldsValue).forEach(([key, value]) => {
          if (!isNaN(value) && value !== '' && value !== null) {
            convertedInfo[key] = parseInt(value);
          } else {
            convertedInfo[key] = value;
          }
        });
        return convertedInfo;
      };
      setValueField(prevState => ({
        ...prevState,
        ...fieldsConvert(),
        ...atributosConvert(),
      }));
    }
    setFields(fields);
    setOpenLoading(false);
  }

  const handleChangeMain = async (value, fields) => {
    let dataFull = {...valueField, [fields]: value};
    let nullData = {};

    if (fields === 'id_tercero_cliente' || fields === 'id_sucursal') {
      let filterItem = {};
      if (fields === 'id_tercero_cliente') {
        filterItem = {id_sucursal: [{value: value, key: 'id_tercero'}]};
        nullData = {...nullData, id_sucursal: null, id_equipo: null};
      } else if (fields === 'id_sucursal') {
        nullData = {...nullData, id_equipo: null};
        filterItem = {
          id_equipo: [
            {value: valueField.id_tercero_cliente, key: 'id_tercero'},
            {value: value, key: 'id_sucursal'},
          ],
        };
      }
      setDependencyFilter({...dependencyFilter, ...filterItem});
    }

    setValueField({...dataFull, ...nullData});
  };

  const saveData = async () => {
    const validateInfo = validateData(field, setError, valueField);
    let containArchive = false;
    if (validateInfo.atributos && validateInfo.atributos.length > 0) {
      for (let i = validateInfo.atributos.length - 1; i >= 0; i--) {
        const element = validateInfo.atributos[i];
        if (element.tipo === 'archivo') {
          element.texto && delete element.texto;
          if (
            element.obligatorio === true &&
            !base64File[element.id_atributo]
          ) {
            setError(prevState => ({
              ...prevState,
              [element.id_atributo]: 'El archivo es obligatorio',
            }));
            swal('Error', `El archivo ${element.item} es obligatorio`, 'error');
            return; // Termina la ejecución de saveData
          }
          validateInfo.atributos.splice(i, 1); // Elimina el elemento actual
          containArchive = {
            contain: true,
            codigo: element.id_atributo,
          };
        }
      }
    }
    if (validateInfo) {
      setOpenLoading(true);
      const convertInfo = {
        ...validateInfo,
        ...(validateInfo?.id_tercero_cliente && {
          id_tercero_cliente: parseInt(validateInfo.id_tercero_cliente),
        }),
        ...(validateInfo?.id_sucursal && {
          id_sucursal: parseInt(validateInfo.id_sucursal),
        }),
        ...(validateInfo?.id_equipo && {
          id_equipo: parseInt(validateInfo.id_equipo),
        }),
      };

      await saveInfo(convertInfo)
        .then(async response => {
          const dataResponse = response.data[0];

          if (
            dataResponse.respuesta >= 200 &&
            dataResponse.respuesta <= 299 &&
            Object.keys(base64File).length > 0
          ) {
            saveFile(dataResponse.id, base64File).then(response => {
              if (response.data[0].respuesta !== 200) {
                return swal(
                  'Se produjo un error',
                  'Descripción' + response?.data?.[0]?.descripcion,
                  'error',
                );
              }
            });
          }
          setValueField({});

          if (dataResponse.respuesta >= 200 && dataResponse.respuesta <= 299) {
            swal({
              title: 'Guardado exitoso',
              text: 'Descripción: ' + response?.data?.[0]?.descripcion,
              icon: 'success',
              button: 'Cerrar',
            }).then(() => refreshPage());
          } else {
            swal({
              title: 'Se produjo un error',
              text: 'Descripción' + response?.data?.[0]?.descripcion,
              icon: 'error',
              button: 'Cerrar',
            }).then(() => refreshPage());
          }
          resetFileInfo();
          setOpenLoading(false);
        })
        .catch(error => {
          swal({
            title: 'Hemos tenido problemas con el guardado intenta de nuevo',
            text: error,
            icon: 'error',
            button: 'Cerrar',
          }).then(() => refreshPage());
        });
    }
  };

  function resetFileInfo() {
    setFileInfo({
      nombre: 'Archivo(jpg, png, pdf)',
      descripcion: '',
    });
  }

  function refreshPage() {
    window.location.reload(true);
  }
  return (
    <Container className={'mainBody'} maxWidth="md">
      <Loading open={openLoading} />
      {!isOfficeAuthenticated && enableOfficeAuth ? (
        <Grid item xs={12}>
          <Typography variant="h5" component="h5" className="textCenter">
            Por favor inicia sesión con Office 365 para continuar:
          </Typography>
          <Button className="pushable" onClick={handleOfficeLogin}>
            <span className="front">Iniciar sesión con Office 365</span>
          </Button>
        </Grid>
      ) : (
        <>
          <Grid item xs={12}>
            <div
              className={'logoMain'}
              style={{backgroundImage: 'url(' + imageCompany + ')'}}></div>
            <Typography
              variant="h2"
              component="h2"
              className={'colorMainBlue textCenter titleClassH2'}>
              SOLICITUD DE SERVICIOS TÉCNICOS
            </Typography>

            <Typography variant="h5" component="h5" className={'textCenter'}>
              Por favor ingrese la información correspondiente al servicio
              técnico que requiere:
            </Typography>
          </Grid>

          <Form
            field={field}
            handleChangeMain={handleChangeMain}
            error={error}
            dependencyFilter={dependencyFilter}
            valueField={valueField}
            setNameFile={setFileInfo}
            nameFile={fileInfo}
            setBase64File={setBase64File}
            serialNumber={serialNumber}
          />

          <Grid item xs={12}>
            <Typography variant="h6" component="h6" className={'marginTop20'}>
              Actualizaremos la información almacenada, usada y tratada de
              conformidad con las Políticas de Privacidad de la empresa
            </Typography>
            {Object.keys(field)?.length > 0 && (
              <Button className="pushable" onClick={saveData}>
                <span className="front">ENVIAR</span>
              </Button>
            )}
          </Grid>
        </>
      )}
      <Grid container rowSpacing={1} className={'footer'}>
        <Grid item xs={12} sm={4}>
          <span className={'colorWhite'}>
            Desarrollado por Idae Soluciones
            <br />
            Versión {process.env.REACT_APP_VERSION}
          </span>
        </Grid>

        <Grid item xs={12} sm={8}>
          <ul>
            <li>
              <a href="https://www.idaesoluciones.com/" target="_new">
                Visítanos
              </a>
            </li>
          </ul>
        </Grid>
      </Grid>
    </Container>
  );
}

export default App;
